import { render, staticRenderFns } from "./couponSettingsS.vue?vue&type=template&id=19229c62&scoped=true&"
import script from "./couponSettingsS.vue?vue&type=script&lang=js&"
export * from "./couponSettingsS.vue?vue&type=script&lang=js&"
import style0 from "./couponSettingsS.vue?vue&type=style&index=0&id=19229c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19229c62",
  null
  
)

export default component.exports